import React from 'react';
import styles from './AdminMobileMoveBackBtn.module.css';
import useCustomAdminMobileMove from 'routes/adminMobile/hooks/useCustomAdminMobileMove';

const AdminMobileMoveBackBtn = () => {
    const {moveToBack} = useCustomAdminMobileMove();

    return (
        <div className={styles.moveBtn} onClick={() => moveToBack()}>
            <span>&lt;</span>
        </div>
    );
};

export default AdminMobileMoveBackBtn;